type DischargeSummaryDraftToken = `visit-${number}-dischargeSummary`;

export const getDischargeSummaryDraftToken = (visitId: number): DischargeSummaryDraftToken =>
   `visit-${visitId}-dischargeSummary`;
